import { Component, OnInit } from '@angular/core';
import { ReporteService } from '@app/core/service/reporte.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService, ProductService } from '@app/core';
import { Category } from '@core/model/category.model';
import { Product } from '@core/model/product.model';

@Component({
  selector: 'app-seguimiento',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.css']
})
export class SeguimientoComponent implements OnInit {

  inicio: string;
  final: string;
  existencia: any;
  buscarForm: FormGroup;
  categories: Category[];
  products: Product[];
  isLoading = false;
  constructor(
    private reporteService: ReporteService,
    private categoryService: CategoryService,
    private productoService: ProductService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.listData();
    this.ListarExistencia();
  }

  createForm() {
    this.buscarForm = this.formBuilder.group({
      producto: ['', [Validators.nullValidator]]
      /*   categoria: ['',[Validators.required]],
      producto:['',[Validators.required]]*/
    });
  }
  getSelectedProduct(event: Product) {
    // alert(event);
    // console.log('Producto Changed: ' + event.producto_id);
    // console.log(JSON.stringify(event));
    // this.resetPurchase();
    // this.showDiv = null;
    // console.log(i);
    //  this.patchValues(event.producto_id, i);
    // this.addressCustomer = event.address;
  }
  listData() {
    // listando cattegorias

    // listtando producto
    this.productoService.getProductosExistencia().subscribe(
      data => {
        // console.log(data);
        this.products = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  ListarExistencia() {
    /* const data = {
       fecha_inicio: '2019/11/02',
       fecha_final: '2019/12/02'
     };*/

    // alert(mes);
    const data = {
      producto_id: 0
    };
    // console.log(data);
    // alert(this.i/**/nicio);
    this.reporteService.precioProductos(data).subscribe(
      data2 => {
        // console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  buscarExistencia() {
    const data = {
      producto_id: this.buscarForm.value.producto
    };

    console.log(this.buscarForm.value.producto);
    this.reporteService.segProducto(data.producto_id.producto_id).subscribe(
      data2 => {
         console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  checkStatus(stock: Number, lim: Number) {
    if (stock <= lim) {
      return false;
    } else {
      return true;
    }
  }

}
